import { DecimalPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { OnyxAmountPipe } from '@onyx/angular';

@Component({
  selector: 'app-amount-cell',
  imports: [OnyxAmountPipe, DecimalPipe],
  templateUrl: './amount-cell.component.html',
  styleUrl: './amount-cell.component.scss',
})
export class AmountCellComponent {
  public readonly amount =
    input.required<Parameters<OnyxAmountPipe['transform']>[0]>();
  public readonly show =
    input<Parameters<OnyxAmountPipe['transform']>[1]>('value');
  public readonly short = input(true);
  public readonly decimalPlaces = input(2);
  public readonly percentage = input<number | null>(null);
}
